import Swiper from "swiper";

class ApplicationSlider {
  constructor() {
    this.component = document.querySelector(
      '[data-component="application-slider"]'
    );
    this.trigger = document.querySelector(
      '[data-trigger="application-slider"]'
    );
    this._init();
  }

  _init() {
    if (this.component) {
      let swiper = null;

      swiper = new Swiper(this.trigger, {
        slidesPerView: 3,
        spaceBetween: 60,
        breakpoints: {
          // when window width is >= 320px
          750: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          1123: {
            slidesPerView: 2,
            spaceBetween: 30
          }
        },
        navigation: {
          nextEl: ".categorie-applications__next",
          prevEl: ".categorie-applications__prev"
        }
      });
    }
  }
}

export const applicationSlider = new ApplicationSlider();
